export const REGISTRATION_PROCESSING = 'REGISTRATION_PROCESSING'
export const REGISTRATION_FAILED = 'REGISTRATION_FAILED'
export const REGISTRATION_SUCCESSFUL = 'REGISTRATION_SUCCESSFUL'


// WEBPACK FOOTER //
// ./src/registration/constants.js